// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';
import './third/jquery.product-list-slider';

export default class ProductListSlider extends WebComponent {
  enterDocument() {
    const availableSliders = $(this.element);
    for ( var i = 0; i <= availableSliders.length; i++ ) {
      $(this.element).productListSlider();
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ProductListSlider.js